import { DashboardR } from "./index";
import { DashboardR2 } from "./index0";
import { DashboardR3 } from "./index1";
import { DashboardR4 } from "./index2";
import { DashboardR5 } from "./index3";
import { DashboardR6 } from "./index4"; 
// 
/*
export const DashboardR={
      index: true,
      element: <DashboardIndex />,
      loader: itloader,
    } */

export const dashboardMap = {
 R: DashboardR,
 R2: DashboardR2,
 R3: DashboardR3,
 R4: DashboardR4,
 R5: DashboardR5,
 R6: DashboardR6
};
